import React from 'react';
import PropTypes from 'prop-types';
import {SearchField} from 'components';
import LayoutCheckbox from 'components/forms/layoutCheckbox';
import LayoutSelect from 'components/forms/layoutSelect';
import VolumeCalculator from 'helpers/volumeCalculator';
import Row from 'components/Row';
import Col from 'components/Col';
import {chemicalBaseTypeNames, chemicalBaseTypes} from 'helpers/constants';
import DealerApi from 'api/dealer';
import ValidateGroup from 'helpers/validation';
import getProductDict from 'page/customer/system/productDict';
import session from 'services/sessionService';
import Pool from 'models/pool';
import ProductApi from 'api/product';
import {systemOptionsTags} from 'helpers/dataHelpers';
import merge from 'lodash/merge';
import SearchModal from './SearchModal';
import Button from 'components/layout/Button';
import CustomerApi from 'api/customer';
import PoolApi from 'api/pool';
import get from 'lodash/get';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';


const poolTypes = [
  chemicalBaseTypes.brominePool,
  chemicalBaseTypes.chlorinePool,
  chemicalBaseTypes.softswimPool,
  chemicalBaseTypes.mineralSpringsPool,
  chemicalBaseTypes.saltWaterPool,
];


class Input extends React.Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
    intl: intlShape,
  };

  static initialState = {
    search: '',
    customer: undefined,
    pools: [],
    modalOpen: false,
    loaded: false,
    conversionMethod: 'Chlorine',
    pool: new Pool({typeID: 1, finish: 'U', property: 'R', ionization: false}),
    newPool: new Pool({typeID: 1, finish: 'U', property: 'R', ionization: false}),
    productDict: {
      sanitizer: {
        keys: [],
        names: [],
      },
    },
    newProductDict: {
      sanitizer: {
        keys: [],
        names: [],
      },
    },
  };

  constructor(props) {
    super(props);

    this.group = new ValidateGroup(this._submit);
    this.state = Input.initialState;
  }

  componentWillMount() {
    Promise.all([
      ProductApi.getProducts(),
      DealerApi.getDealer(session.getUser().dealerId),
    ])
      .then(([products, dealer]) => {
        const {pool: _pool, newPool: _newPool} = this.state;
        const {pool, productDict} = getProductDict({pool: _pool, products, dealer, formatMessage: this.props.intl.formatMessage});

        _newPool.sanitizer = productDict.sanitizer.products.find(x => x.chemicalBaseTypeID !== productDict.sanitizer.chemicalBaseType).id;
        const {pool: newPool, productDict: newProductDict} = getProductDict({
          pool: _newPool,
          products,
          dealer,
          formatMessage: this.props.intl.formatMessage,
          customFilter: p => productDict.ionization || p.chemicalBaseTypeID !== productDict.sanitizer.chemicalBaseType,
        });

        this.setState({products, dealer, productDict, newProductDict, newPool, pool, loaded: true});
      });
  }

  reset = () => {
    const {dealer, products} = this.state;
    const nextState = merge(Input.initialState, {loaded: true});

    const {pool, productDict} = getProductDict({pool: nextState.pool, products, dealer, formatMessage: this.props.intl.formatMessage});
    const {pool: newPool, productDict: newProductDict} = getProductDict({
      pool: nextState.newPool,
      products,
      dealer,
      formatMessage: this.props.intl.formatMessage,
    });

    this.vc.internalChange('volume')({target: {value: undefined}});

    this.setState(merge(nextState, {pool, productDict, newPool, newProductDict}));

    this.props.onReset();
  };

  toggleCustomerSearchModal = () => {
    this.setState(prevState => ({modalOpen: !prevState.modalOpen}));
  };

  search = search => {
    this.setState({search, modalOpen: true});
  };

  choosePool = ({value}) => {
    const {pools} = this.state;

    if (pools && pools.length && value) {
      const pool = pools.find(x => x.id === value) || pools[0];

      return this._setPool('pool', pool, undefined, () => {
        this.setSanitizer('pool')({value: pool.sanitizer});
      });
    }
  };

  setSanitizer = (target = 'pool') => ({value}) => {
    const p = this.state[target].clone();
    const {[target === 'pool' ? 'productDict' : 'newProductDict']: productDict} = this.state;

    p.sanitizer = value;

    this._setPool(target, p, undefined, () => {
      if (target === 'pool') {
        const newPool = this.state.newPool.clone();

        if (this.state.productDict.sanitizer.chemicalBaseType === this.state.newProductDict.sanitizer.chemicalBaseType &&
          !this.state.pool.ionization) {
          newPool.sanitizer = productDict.sanitizer.products.find(x => x.chemicalBaseTypeID !== productDict.sanitizer.chemicalBaseType);
        }

        this._setPool('newPool', newPool);
      }
    });
  };

  setPool = (target = 'pool') => ({key, value}) => {
    const targets = [];

    if (target === 'all') {
      targets.push('pool');
      targets.push('newPool');
    } else {
      targets.push(target);
    }

    targets.forEach(t => {
      const pool = this.state[t].clone();

      pool[key] = value;

      this._setPool(t, pool);
    });
  };

  _setPool = (target, updated, chemBaseType = get(this.state.productDict, 'sanitizer.chemicalBaseType'), cb = () => {}) => {
    const {products, dealer} = this.state;
    const old = this.state[target];

    const {pool, productDict} = getProductDict({
      pool: updated,
      products,
      dealer,
      formatMessage: this.props.intl.formatMessage,
      prevPool: old,
      customFilter: target === 'newPool' ? p => this.state.pool.ionization || chemBaseType !== p.chemicalBaseTypeID : undefined,
    });

    this.setState({[target]: pool, [target === 'newPool' ? 'newProductDict' : 'productDict']: productDict}, cb);
  };

  _submit = () => {
    this.props.onSubmit(this.state);
  };

  selectCustomer = id => {
    this.setState({loading: true});
    Promise.all([CustomerApi.getCustomer(id), PoolApi.getList(id)])
      .then(([customer, pools]) => {
        const pool = pools.length > 0 ? pools[0] : this.state.pool;

        this.setState({customer, pools, loading: false, pool},
          () => {
            const contact = customer.customerContacts.find(x => !!x.name);

            this.setSanitizer('pool')({value: pool.sanitizer});

            if (!this.searchField || !contact) {return;}

            this.searchField._setValue(contact.name);
          });
      });
  };

  render() {
    const{customer, pool, productDict, newProductDict, newPool, conversionMethod} = this.state;
    const {formatMessage} = this.props.intl;

    const simpleFormat = id => formatMessage({id});

    const poolNames = [];
    const poolIDs = [];

    if (customer && customer.pools) {
      for (let p of customer.pools.filter(x => poolTypes.includes(x.sanitizerType))) {
        poolIDs.push(p.id);
        poolNames.push(p.nickName || chemicalBaseTypeNames(1, p.sanitizerType, formatMessage));
      }
    }

    const poolOptions = systemOptionsTags[pool.typeID || 1];


    return <div>
      {this.state.modalOpen ?
        <SearchModal defaultValue={this.state.search}
                     debounceDelay={500}
                     onClose={this.toggleCustomerSearchModal}
                     onSelect={this.selectCustomer}/> :
        null}

      <div className='qc-system-conversion__input'>
        <div className='qc-system-conversion__input--customer-box'>
          <Row>
            <Col md={8}>
              <div className='form-group'>
                <label><FormattedMessage id='general.customer' /></label>
                <SearchField onSearch={this.search}
                             ref={r => this.searchField = r}
                             placeholder={formatMessage({id: 'customer.search.placeholder'})} />
              </div>
            </Col>
            <Col md={4}>
              <LayoutSelect label={formatMessage({id: 'general.system'})}
                            disabled={!poolNames.length}
                            options={poolNames}
                            dataKey='system'
                            value={pool && pool.id}
                            dataChanged={this.choosePool}
                            keys={poolIDs} />
            </Col>
          </Row>
        </div>

        <Row>
          <Col md={4}>
            <div key='volume' className='form-group'>
              <label>Volume<span className='error' style={{marginLeft: 2}}>*</span></label>
              <VolumeCalculator
                ref={r => this.vc = r}
                dataKey='volume'
                beforeFocus={false}
                volume={pool.volume}
                group={this.group}
                region={(this.state.dealer || {}).country}
                poolType={1}
                title={formatMessage({id: 'w'})}
                editMode={true}
                onBlur={this.setPool('all')}
                onChange={this.setPool('all')} />
            </div>
          </Col>

          <Col md={4}>
            <LayoutSelect dataKey='finish'
                          label={formatMessage({id: 'general.finish'})}
                          value={pool.finish}
                          options={Object.values(poolOptions.finish).map(simpleFormat)}
                          dataChanged={this.setPool('all')}
                          keys={Object.keys(poolOptions.finish)} />
          </Col>

          <Col md={4}>
            <LayoutSelect dataKey='property'
                          label={formatMessage({id: 'general.installation.type'})}
                          value={pool.property}
                          options={Object.values(poolOptions.property).map(simpleFormat)}
                          dataChanged={this.setPool('all')}
                          keys={Object.keys(poolOptions.property)} />
          </Col>

          <Col md={4}>
            <LayoutSelect dataKey='sanitizer'
                          label={formatMessage({id: 'quick-calcs.system-conversion.sanitizer.current'})}
                          value={pool.sanitizer}
                          dataChanged={this.setSanitizer('pool')}
                          options={productDict.sanitizer.names}
                          keys={productDict.sanitizer.keys} />
          </Col>

          <Col md={4}>
            {productDict.sanitizer.chemicalBaseType !== chemicalBaseTypes.softswimPool ?
              <LayoutCheckbox dataKey='ionization'
                              label={formatMessage({id: 'system.details.ionization.catalyst'})}
                              value={pool.ionization}
                              dataChanged={this.setPool('all')} /> :
              <LayoutSelect dataKey='conversionMethod'
                            label={formatMessage({id: 'quick-calcs.system-conversion.method'})}
                            value={conversionMethod}
                            dataChanged={({value}) => this.setState({conversionMethod: value})}
                            options={['Chlorine', 'Oxysheen', 'Drain']} />}
          </Col>

          <Col md={4}>
            <LayoutSelect dataKey='sanitizer'
                          label={formatMessage({id: 'quick-calcs.system-conversion.sanitizer.desired'})}
                          value={newPool.sanitizer}
                          dataChanged={this.setSanitizer('newPool')}
                          options={newProductDict.sanitizer.names}
                          keys={newProductDict.sanitizer.keys} />
          </Col>
        </Row>
      </div>

      <Row>
        <Col md={12}>
          <div className='qc-system-conversion__buttons pull-right'>
            <Button link onClick={this.reset}><FormattedMessage id='quick-calcs.reset' /></Button>
            <Button primary onClick={() => this.group.validate()}><FormattedMessage id='quick-calcs.calculate' /></Button>
          </div>
        </Col>
      </Row>
    </div>;
  }
}

export default injectIntl(Input);
